"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  getActiveVariation: () => getActiveVariation,
  getExternalIds: () => getExternalIds,
  getSplitKey: () => getSplitKey
});
module.exports = __toCommonJS(src_exports);

// src/variation.ts
var import_json_logic_js = __toESM(require("json-logic-js"));
var isBrowser = typeof window !== "undefined" && window != null && typeof window.document !== "undefined";
var BUILTIN_TRAITS_UNKNOWN = {
  pageUrl: "unknown"
};
var getBrowserBuiltinTraits = () => {
  if (!isBrowser) {
    return {};
  }
  return {
    pageUrl: document.location.href
  };
};
var getSplitKey = (split) => {
  return `${split.type === "experiment" ? "exp." : "seg."}${split.id}`;
};
function getActiveVariation(opts) {
  const { splits, getKnownValue, updateKnownValue } = opts;
  const getRandomValue = (key) => {
    if (opts.getRandomValue) {
      return opts.getRandomValue(key);
    }
    return Math.random();
  };
  const variation = {};
  splits.forEach((split) => {
    const key = getSplitKey(split);
    const knownVal = getKnownValue(key);
    if (knownVal) {
      variation[key] = knownVal;
      return;
    }
    const numSlices = split.slices.length;
    let chosenSlice = void 0;
    if (split.type === "experiment") {
      let p = getRandomValue(split.id);
      chosenSlice = split.slices[numSlices - 1];
      for (let i = 0; i < numSlices; i++) {
        if (p - split.slices[i].prob <= 0) {
          chosenSlice = split.slices[i];
          break;
        }
        p -= split.slices[i].prob;
      }
    } else if (split.type === "segment") {
      for (let i = 0; i < numSlices; i++) {
        if (import_json_logic_js.default.apply(split.slices[i].cond, __spreadValues(__spreadValues(__spreadValues({
          time: (/* @__PURE__ */ new Date()).toISOString()
        }, BUILTIN_TRAITS_UNKNOWN), getBrowserBuiltinTraits()), opts.traits))) {
          chosenSlice = split.slices[i];
        }
      }
    }
    if (chosenSlice) {
      variation[key] = chosenSlice.id;
      if (split.externalId && chosenSlice.externalId) {
        variation[`ext.${split.externalId}`] = chosenSlice.externalId;
      }
      if (split.type === "experiment") {
        updateKnownValue(key, chosenSlice.id);
      }
    }
  });
  return variation;
}
function getExternalIds(splits, variation) {
  const externalVariation = {};
  Object.keys(variation).forEach((variationKey) => {
    const [, splitId] = variationKey.split(".");
    const sliceId = variation[variationKey];
    const split = splits.find(
      (s) => s.id === splitId || s.externalId === splitId
    );
    if (split && split.externalId) {
      const slice = split.slices.find((s) => s.id === sliceId || s.externalId === sliceId);
      if (slice == null ? void 0 : slice.externalId) {
        externalVariation[`${split.externalId}`] = slice.externalId;
      }
    }
  });
  return externalVariation;
}
//# sourceMappingURL=index.js.map
